import { render, staticRenderFns } from "./QRCodeReader.vue?vue&type=template&id=3914a39f&scoped=true&"
import script from "./QRCodeReader.vue?vue&type=script&lang=js&"
export * from "./QRCodeReader.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeReader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QRCodeReader.vue?vue&type=style&index=1&id=3914a39f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914a39f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRow,VTextField})
